import { createContext, useContext, type ReactNode } from 'react'
import type { BlockViewerPageInfo, PageRef } from '@w/content-blocks'

export type ResolveEditorPage = (ref: PageRef) => BlockViewerPageInfo

const SpaceContext = createContext<string | undefined>(undefined)
const ResolvePageContext = createContext<ResolveEditorPage>(defaultPageInfo)
const OpenPageContext = createContext<((ref: PageRef) => void) | undefined>(
  undefined,
)

export function PageInfoProvider({
  children,
  spaceId,
  onOpenPage,
  resolvePage = defaultPageInfo,
}: {
  spaceId: string
  children: ReactNode
  onOpenPage?: (ref: PageRef) => void
  resolvePage?: ResolveEditorPage
}) {
  return (
    <SpaceContext.Provider value={spaceId}>
      <ResolvePageContext.Provider value={resolvePage}>
        <OpenPageContext.Provider value={onOpenPage}>
          {children}
        </OpenPageContext.Provider>
      </ResolvePageContext.Provider>
    </SpaceContext.Provider>
  )
}

export function usePageInfo() {
  const spaceId = useContext(SpaceContext)
  const onOpenPage = useContext(OpenPageContext)
  const resolvePage = useContext(ResolvePageContext)
  if (spaceId === undefined) throw new Error('PageInfoProvider requires a containing space')
  return {
    spaceId,
    onOpenPage,
    resolvePage,
  }
}

function defaultPageInfo(_ref: PageRef): BlockViewerPageInfo {
  return { label: 'Page unavailable' }
}
